import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment';
import i18next from 'i18next';

import { PageTitle } from '../PageTitle';
import { EventConfigurationsService, TagsService, TimeFormattingService } from "../../services";
import { FormatHelper } from '../../helpers';

import config from "config";

@connect(state => {
  return {
    me: state.user.me
  }
})
class EventConfigurationView extends React.Component {

  constructor(props) {
    super(props);

    const supportForAutoResolutionEnabledFlag = props.me.enterprise.enterprisePreferences.find(pref => pref.token === 'ALERT_SERVICE_AUTO_RESOLUTION_ENABLED');
    
    this.state = {
      alertConfiguration: null,
      eventConfigurationId: props.match.params.eventConfigurationId,
      errorMessage: null,
      supportForAutoResolutionEnabled: supportForAutoResolutionEnabledFlag && supportForAutoResolutionEnabledFlag.numericValue === 1
    };
  }

  componentDidMount() {
    EventConfigurationsService.get(this.state.eventConfigurationId).then((response) => {
      this.setState({ alertConfiguration: response.eventConfiguration });
    }).catch((error) => {
      this.setState({ errorMessage: i18next.t('messages.could-not-load-event-configuration') });
      console.error(error);
    });

    TagsService.getDeviceCounts().then(response => {
      this.setState({counts: response.counts})
    }).catch(error => {
      console.error(error); // TODO handle error
    });
  }

  render() {
    if (this.state.errorMessage) {
      return (
          <Redirect to={{
            pathname: '/config/events',
            state: {
              errorMessage: this.state.errorMessage
            }
          }}/>
      );
    }

    if (this.state.alertConfiguration && this.state.counts) {
      const actions = this.state.alertConfiguration.alertConfigurationActions
                      .filter(action => !action.archived)
                      .map(action =>
                        <AlertConfigurationActionDetail key={action.id} action={action} deviceCounts={this.state.counts} supportForAutoResolutionEnabled={this.state.supportForAutoResolutionEnabled} />
                      );
      const alertExemptTimes = this.state.alertConfiguration.alertExemptTimes
                    .filter(alertExemptTime => !alertExemptTime.archived)
                    .map(alertExemptTime =>
                      <AlertExemptTimesDetail key={alertExemptTime.id} alertExemptTime={alertExemptTime} />
                    );
      const backLinkSearch = this.props.location.state && this.props.location.state.backLinkSearch ? this.props.location.state.backLinkSearch : null;

      return (
          <div>
            <div className="row">
              <PageTitle title={this.state.alertConfiguration.name}
                         subTitle={this.state.alertConfiguration.description}
                         backLinkWithParams={{
                           link: {
                             pathname: "/config/events",
                             search: backLinkSearch
                           }
                         }}
                         editLinkWithParams={{
                           link: {
                             pathname: `/config/events/edit/${this.state.alertConfiguration.id}`,
                             uiroute: '/config/events/edit/:eventConfigurationId',
                             state: {
                               backLinkSearch: backLinkSearch
                             }
                           }
                         }} />
            </div>

            <div className="op-content-box">
              <div className="row">
                <div className="col-sm-6 col-md-4 form-group">
                  <div className="card-data-cell remove-border-left card-data-cell-icon card-icon-name">
                    <label>{ i18next.t('pages.event-configurations.status') }</label><p>{ i18next.t(`alert-configuration-statuses.${this.state.alertConfiguration.alertConfigurationStatus.token}`) }</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="op-content-box">
              <h4 className="remove-margin-bottom">{ i18next.t('pages.event-configurations.exempt-times') }</h4>
              <div className="row">
                {alertExemptTimes}
              </div>
            </div>

            <div className="op-content-box">
              <h4 className="remove-margin-bottom">{ i18next.t('pages.event-configurations.conditions') }</h4>
              <div className="row">
                {actions}
              </div>

            </div>
          </div>

      );
    } else {
      return (
          <div className="loader">{ i18next.t('loading') }</div>
      );
    }
  }

}

class AlertExemptTimesDetail extends React.Component {
  showSelectedDays(alertExemptTime) {
    moment.locale(i18next.language);

    let selectedDays = [];

    if (alertExemptTime['monday'] === true) {
      selectedDays.push(moment.weekdays(1));
    }

    if (alertExemptTime['tuesday'] === true) {
      selectedDays.push(moment.weekdays(2));
    }

    if (alertExemptTime['wednesday'] === true) {
      selectedDays.push(moment.weekdays(3));
    }

    if (alertExemptTime['thursday'] === true) {
      selectedDays.push(moment.weekdays(4));
    }

    if (alertExemptTime['friday'] === true) {
      selectedDays.push(moment.weekdays(5));
    }

    if (alertExemptTime['saturday'] === true) {
      selectedDays.push(moment.weekdays(6));
    }

    if (alertExemptTime['sunday'] === true) {
      selectedDays.push(moment.weekdays(0));
    }

    return selectedDays.join(', ');
  }

  render() {
    return (
        <div className="col-sm-12 oc-mini-card oc-mini-card-gray">
          <div className="inner">
            <div className="row">
              {
                this.props.alertExemptTime.startAtTime == 0 && this.props.alertExemptTime.endAtTime == (24 * 60 * 60) ?
                <div>
                  <div className="col-sm-6 col-md-4 col-lg-3"><label>{ i18next.t('form-labels.start') }</label> <p>{ i18next.t('form-labels.all-day') }</p></div>
                  <div className="col-sm-6 col-md-4 col-lg-3"></div>
                </div>
                :
                <div>
                  <div className="col-sm-6 col-md-4 col-lg-3"><label>{ i18next.t('form-labels.start') }</label> <p>{TimeFormattingService.secondsToHoursMinutes(this.props.alertExemptTime.startAtTime) }</p></div>
                  <div className="col-sm-6 col-md-4 col-lg-3"><label>{ i18next.t('form-labels.end') }</label> <p>{TimeFormattingService.secondsToHoursMinutes(this.props.alertExemptTime.endAtTime) }</p></div>
                </div>
              }
              <div className="col-sm-6 col-md-4 col-lg-3"><label>{ i18next.t('form-labels.days-of-week') }</label> <p>{this.showSelectedDays(this.props.alertExemptTime) }</p></div>
            </div>
            {
              this.props.alertExemptTime.endAtTime < this.props.alertExemptTime.startAtTime ? 
              <div className="row">
                <div className="col-sm-12 col-md-6 col-lg-6">* { i18next.t('form-labels.overnight-note') }</div>
              </div>
              :
              null
            }
          </div>
        </div>
    );
  }
}

class AlertConfigurationActionDetail extends React.Component {
  render() {
    let measurementValue = FormatHelper.formatMeasurement(this.props.action.threshold);

    return (
        <div className="col-sm-12 oc-mini-card oc-mini-card-gray">
          <div className="inner">
            <div className="row">
              <div className="col-sm-6 col-md-4 col-lg-3"><label>{ i18next.t('form-labels.threshold') }</label> <p>{this.props.action.threshold.name}</p></div>
              <div className="col-sm-6 col-md-4 col-lg-3">
                  <label>{ this.props.action.threshold.deviceDataClassification ? i18next.t('form-labels.measurement-type') : i18next.t('form-labels.measurement') }</label>
                  <p>
                    <img src={`${config.WEB_BASE_URL}/images/icon/sensor_${this.props.action.threshold.thresholdClassification.token}.svg`} height="16" />&nbsp;
                    {this.props.action.threshold.deviceDataClassification?.name ?? (this.props.action.threshold.deviceDataType?.name ?? "Unknown")}&nbsp;
                    <span className="threshold-evaluation">{this.props.action.threshold.thresholdEvaluationType.shortForm}</span>&nbsp;
                    {measurementValue}
                  </p>
              </div>
              <div className="col-sm-6 col-md-4 col-lg-3"><label>{ i18next.t('form-labels.duration-in-minutes') }</label> <p>{this.props.action.duration / 60}</p></div>
              <div className="col-sm-6 col-md-4 col-lg-3"><label>{ i18next.t('form-labels.level') }</label> <p className={`criticality-indicator criticality-${this.props.action.alertLevel.token}`}>{i18next.t(`alert-levels.${this.props.action.alertLevel.token}`)}</p></div>
              <div className="col-sm-6 col-md-4 col-lg-3"><label>{ i18next.t('form-labels.originating-from') }</label> <p>{this.props.action.deviceGroup.name}</p></div>
              <div className="col-sm-6 col-md-4 col-lg-3"><label>{ i18next.t('form-labels.action-type') }</label> <p>{this.props.action.action.name}</p></div>
              {
                this.props.supportForAutoResolutionEnabled ?
                <div className="col-sm-6 col-md-4 col-lg-3"><label>{ i18next.t('form-labels.notification-threshold-resolution') }</label> <p>{this.props.action.resolutionNotificationEnabled ? i18next.t('enabled') : i18next.t('disabled')}</p></div>
                : null
              }
              {
                this.props.supportForAutoResolutionEnabled ?
                <div className="col-sm-6 col-md-4 col-lg-3"><label>{ i18next.t('form-labels.automatically-mark-resolved') }</label> <p>{this.props.action.autoResolutionEnabled ? i18next.t('enabled') : i18next.t('disabled')}</p></div>
                : null
              }
              <div className="col-sm-12 col-md-6 form-group">
                <div className="card-data-cell remove-border-left">
                  <label>{ i18next.t('form-labels.will-only-match-assets-with-tags') }</label>
                  {this.props.action.threshold.tags.length > 0 ?
                    this.props.action.threshold.tags.map((tag, index) => <p className="alert-tag" key = {index}> {tag.name} <span>({this.props.deviceCounts[tag.id].deviceCount})</span></p>) :
                  <p>{ i18next.t('none') }</p>}
                </div>
              </div>
            </div>
          </div>
        </div>

    );
  }
}

export default EventConfigurationView;
